import {
  createClient,
  dedupExchange,
  cacheExchange,
  fetchExchange,
} from "urql";

export const client = new createClient({
  url: process.env.NEXT_PUBLIC_HASURA_URL,
  fetchOptions: () => {
    return {
      headers: {
        "x-hasura-admin-secret": process.env.NEXT_PUBLIC_SECRET_KEY,
      },
    };
  },
  exchanges: [dedupExchange, fetchExchange, cacheExchange],
  requestPolicy: "cache-and-network",
});
